import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class Home extends Component {
  render() {
    return (
    <div className="App">
		<EWH id="ewh-fascione-hp-ballottaggio" title="Fascione HP" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/fascione-hp.html?cid=ewh-fascione-hp-ballottaggio&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
	    <EWH id="ewh-fascione-hp-elezioni" title="Fascione HP Elezioni" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/fascione-hp-elezioni.html?cid=ewh-fascione-hp-elezioni&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
	    <EWH id="ewh-mappa-italia" title="Mappa Italia" repo='/elezioni/withub/comunali-2026/comunali-ballottaggio/mappa-italia.html?cid=ewh-mappa-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
    </div>
    )
  }
}

export default Home
